export default __webpack_public_path__ + "static/media/sip-picturemark-d.0fa69b4b.svg";